"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyles = void 0;

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var getStyles = function getStyles(theme) {
  var _theme$brand, _theme$brand$colors;

  var primaryColor = (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary;
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  return {
    cursor: "pointer",
    border: "none",
    background: "transparent",
    borderRadius: "6px",
    padding: 0,
    marginLeft: "6px",
    height: "24px",
    width: "24px",
    transition: "background 200ms ease-in-out",
    "&:hover": {
      background: tcPrimaryColor.setAlpha(0.14).toRgbString()
    }
  };
};

exports.getStyles = getStyles;